import { ExpenseCategory } from '../types/database';
import { TAX_YEAR_MONTHS, calendarYearForMonth } from '../utils/taxUtils';
import { formatMonth } from './format';

/**
 * Expense categories, loosely following HMRC's allowable-expense groups.
 * Colours are the validated categorical palette (dark steps, checked against the
 * app surface) assigned in fixed order — never re-ordered or cycled.
 */
export const EXPENSE_CATEGORIES: { id: ExpenseCategory; label: string; color: string }[] = [
  { id: 'travel', label: 'Travel & vehicle', color: '#3987e5' },
  { id: 'equipment', label: 'Equipment & tools', color: '#d95926' },
  { id: 'office', label: 'Phone, internet & office', color: '#199e70' },
  { id: 'software', label: 'Software & subscriptions', color: '#c98500' },
  { id: 'training', label: 'Training & courses', color: '#d55181' },
  { id: 'clothing', label: 'Uniform & clothing', color: '#008300' },
  { id: 'professional', label: 'Accountancy & fees', color: '#9085e9' },
  { id: 'other', label: 'Other', color: '#e66767' },
];

const byId = new Map(EXPENSE_CATEGORIES.map((c) => [c.id, c]));

export const getExpenseCategory = (id: ExpenseCategory) => byId.get(id) ?? byId.get('other')!;

/** Dropdown options for picking a category, with its colour swatch. */
export const CATEGORY_OPTIONS = EXPENSE_CATEGORIES.map((c) => ({ value: c.id, label: c.label, dot: c.color }));

/** Dropdown options for the twelve months of a tax year: "April 2026" … "March 2027". */
export const taxYearMonthOptions = (taxYearStart: number) =>
  TAX_YEAR_MONTHS.map((m) => ({ value: String(m), label: formatMonth(calendarYearForMonth(taxYearStart, m), m) }));
